import * as API from '@/api';
import DEFINES from '@/defines';
import {getField, updateField} from 'vuex-map-fields';
import momentTz from 'moment-timezone';

//initial state
function initialState () {
  return {
    list: [],
  };
}
const state = initialState ();

// actions

const actions = {
  async list (context, payload) {
    var response = await API.adminCompany.list (payload);
    // set company in list
    context.commit ('set_list', {
      companies: response.companies.data,
    });
    return response;
  },
  async get (context, payload) {
    var response = await API.adminCompany.get (payload);
    return response.company;
    // var company = context.getters['getCompany'] (payload.id);
    /* If not in state, get from API */
    // if (!company) {
    //   var response = await API.adminCompany.get (payload);
    //   return response.company;
    // }
    // return company;
  },
  async update (context, payload) {
    var response = await API.adminCompany.update (payload);
    context.commit ('update_company', {
      company: response.company,
    });
    return response;
  },
  async consumeAddOns(context, payload) {
    var response = await API.adminCompany.consumeAddOns(payload);
    context.commit('update_company', {
      company: response.company,
    });
    return response;
  },
  async logoutMembers(context, payload){
    var response = await API.adminCompany.logoutMembers(payload);
    return response;
  },
  async generateDailyCoMeetingURL(context, payload){
    //get company payment gateways from API
    return await API.adminCompany.generateDailyCoMeetingURL (payload);
  },
  async delete (context, payload) {
    var response = await API.adminCompany.delete (payload);
    return response;
  },
};

//getters

const getters = {
  getField,
  getOwner: state => company_id => {
    var company = state.list.find (company => {
      return company.id == company_id;
    });
    return company.owner;
  },
  getCompanies: state => {
    return state.list;
  },
  getCompany: state => company_id => {
    if (!state.list) {
      return null;
    }
    return state.list.find (company => {
      return company.id == company_id;
    });
  },
  getCompanyTimezone: state => company => {
    if (company.custom_properties && company.custom_properties.timezone) {
      return company.custom_properties.timezone;
    }
    return momentTz.tz.guess (true);
  },
};

// mutations
const mutations = {
  updateField,
  set_list (state, payload) {
    state.list = payload.companies;
  },
  update_company (state, payload) {
    state.list = [
      ...state.list.filter (company => company.id !== payload.company.id),
      payload.company,
    ];
  },
  reset (state) {
    // acquire initial state
    const s = initialState ();
    Object.keys (s).forEach (key => {
      state[key] = s[key];
    });
  },
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
